export default __webpack_public_path__ + "c4e1aa99ef1b2eed291b94391407dbfd.png";